import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { DiscountCodeForm, DiscountCodeFormRef } from 'pages/Discounts/DiscountCodeForm';
import { DiscountCodeZ as DiscountCode } from '@libs/schemas'; //TODO: Client should not access the model directly, they should the schema as it is more likely what trpc returns
import { Button } from '@/components/ui/button';
import { Ticket } from 'lucide-react';
import { useRef } from 'react';

export const EditDiscountCodeSheet = ({
  isOpen,
  onClose,
  selectedDiscountCode,
}: {
  isOpen: boolean;
  onClose: () => void;
  selectedDiscountCode: DiscountCode | null;
}) => {
  const formRef = useRef<DiscountCodeFormRef>(null);

  const handleSave = () => {
    formRef.current?.submit();
  };

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent
        side="right"
        className="p-0 sm:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-full"
      >
        <div className="grid h-full grid-rows-[auto_1fr_auto]">
          {/* Header */}
          <SheetHeader className="border-b bg-white px-6 py-4">
            <div className="flex items-center space-x-3">
              <div className="rounded-lg bg-orange-100 p-2">
                <Ticket className="h-6 w-6 text-orange-600" />
              </div>
              <div>
                <SheetTitle className="text-xl font-semibold text-gray-900">
                  Edit Discount Code
                </SheetTitle>
                {selectedDiscountCode?.code && (
                  <span className="text-sm text-gray-500">{selectedDiscountCode.code}</span>
                )}
              </div>
            </div>
          </SheetHeader>

          {/* Content Area - Scrollable */}
          <div className="overflow-y-auto p-6">
            <DiscountCodeForm
              ref={formRef}
              onCancel={() => onClose()}
              code={selectedDiscountCode}
            />
          </div>

          {/* Footer */}
          <SheetFooter className="border-t bg-gray-50 px-6 py-4">
            <div className="flex w-full items-center justify-end space-x-2">
              <Button variant="outline" onClick={() => onClose()}>
                Cancel
              </Button>
              <Button
                onClick={handleSave}
                disabled={formRef.current?.isDisabled}
                className="bg-orange-600 hover:bg-orange-700"
              >
                Update Discount Code
              </Button>
            </div>
          </SheetFooter>
        </div>
      </SheetContent>
    </Sheet>
  );
};
